import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SingleProfile from './SingleProfile/Index';

const Master = () => {
  return (
    <main id="single_profile">
      <Routes>
        <Route path=":id" element={<SingleProfile />} />
        {/* Optional: add a default or 404 route */}
        {/* <Route path="*" element={<FourOFour />} /> */}
      </Routes>
    </main>
  );
};

export default Master;
